module.exports = __webpack_public_path__ + "static/media/Artboard3.7786f402.png";